import { combineReducers } from 'redux'

import my from './my/reducers'

const jobRecommendationsReducer = combineReducers({
  my,
})

export default jobRecommendationsReducer
